import _ from 'lodash';

import {
  Title,
  ServiceTypePicker,
} from '@/components';

import validationFlow from '@/validation-flow';

export default {
  name: 'Step3ServiceTypeMobileRegion',
  components: {
    [Title.name]: Title,
    [ServiceTypePicker.name]: ServiceTypePicker,
  },
  props: {},
  data: () => ({

  }),
  computed: {},
  methods: {
    goToPreviousStep() {
      this.$router.push({
        name: 'step2VehiculeType',
      });
    },
    goToNextStep: _.debounce(() => {
      validationFlow.validateStep3ServiceTypeMobileRegion();
    }, 100),
  },
  created() {
    // Use this for going to the next step if they go back and pick the same value
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'appointment/SET_SERVICETYPE') {
        this.goToNextStep(this.$router);
      }
    });
  },
};
